import { useMemo } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import {
  PATH_ONBOARDING_PAYEE,
  PATH_ONBOARDING_PAYEE_REQUIREMENT_DETAILS
} from "..";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { useQueryVerifications } from "../../../query/onboarding/queries/useQueryVerifications";
import { useModalExit } from "../components/ModalExit";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { RouteOnboardingRequirementDetails } from "../steps/EligibilityRequirements/RouteOnboardingRequirementDetails";
import { OnboardingModule } from "../types";

const payeeOnboardingModules: OnboardingModule[] = [
  {
    type: "create_account",
    options: {
      accountTypes: ["Business", "Individual"],
      verificationLevel: "Tax",
      show1099Message: true
    }
  },
  {
    type: "certify_tax_payer_info"
  },
  {
    type: "payout_method"
  },
  {
    type: "eligibility_requirements"
  }
];

export const RoutePayeeOnboarding: React.FC = () => {
  const history = useHistory();
  const queryFeatureFlags = useFeatureFlags();
  const queryVerifications = useQueryVerifications();

  const modules = useMemo((): OnboardingModule[] => {
    if (queryFeatureFlags.data?.taxWithholdingOnboarding) {
      return [...payeeOnboardingModules, { type: "tax_withholdings" }];
    }
    return payeeOnboardingModules;
  }, [queryFeatureFlags.data?.taxWithholdingOnboarding]);

  const modalExit = useModalExit();

  return (
    <Switch>
      {/*CUSTOM ROUTE FOR REQUIREMENTS*/}
      <Route
        path={PATH_ONBOARDING_PAYEE_REQUIREMENT_DETAILS}
        component={RouteOnboardingRequirementDetails}
      />

      <OnboardingFlow
        onBack={
          queryVerifications.data?.tax &&
          queryVerifications.data?.tax !== "None"
            ? () => {
                modalExit.open({
                  onboardingType: "Payee"
                });
              }
            : undefined
        }
        basePath={PATH_ONBOARDING_PAYEE}
        modules={modules}
        onSuccess={() => {
          history.push("/member/dashboard");
        }}
      />
    </Switch>
  );
};
